export interface VaultNetworkSwitchDialogData {
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel: string;
}

export enum VaultNetworkSwitchDialogResult {
  Confirm = 'confirm',
  Cancel = 'cancel',
}
